// The outcome permission behind the Ankeri Voyage Share source: a company that adds the outcome's key
// to that source sees this company's voyage modes. The receiving company rejects the key when the
// outcome holds any other permission, since it would then be a working API credential.
export const VOYAGE_SHARE_ENDPOINT = 'voyage_share';

// The receiving company's source, which reads the modes other companies share with it.
export const VOYAGE_SHARE_SOURCE = 'voyage_share';

// The only schedule type the Voyage Share source runs. Its share stays empty until one exists.
export const SYNC_ASSETS_SCHEDULE_TYPE = 'sync_assets';

// The source types an outcome can share every source of, besides the sources it lists.
export const SHAREABLE_SOURCE_TYPES = [
  { title: 'Reported', value: 'reported' },
  { title: 'Voyages', value: 'voyages' },
];

// The form holds endpoints as the config's {id, label} items; a stored outcome holds their ids.
const endpointId = (endpoint) => endpoint?.id ?? endpoint;

export function grantsVoyageShare(endpoints) {
  return (endpoints || []).some((endpoint) => endpointId(endpoint) === VOYAGE_SHARE_ENDPOINT);
}

export function voyageShareNotAlone(endpoints) {
  return grantsVoyageShare(endpoints) && endpoints.length > 1;
}

// The source types to save on an outcome. They go with every save, as [] without the share
// permission: an update stores only the keys it is sent, so leaving them out would keep old types
// that come back the moment the permission is ticked again.
export function sourceTypesToSend(endpoints, sourceTypes) {
  return grantsVoyageShare(endpoints) ? [...(sourceTypes || [])] : [];
}

export function sourceTypesText(sourceTypes) {
  if (!sourceTypes || sourceTypes.length === 0) return 'None';
  return sourceTypes
    .map((type) => SHAREABLE_SOURCE_TYPES.find((t) => t.value === type)?.title ?? type)
    .join(', ');
}

// The companies a mode was shared by: the mode's own `shared_from` and that of each source's data.
export function sharedFromIds(mode) {
  const ids = [mode?.shared_from, ...(mode?.mode_data || []).map((data) => data.shared_from)];
  return [...new Set(ids.filter(Boolean))];
}

// "shared by <company>": its name when the user's token lists the company, otherwise its id, as a
// token names only the companies the user belongs to. Null when nobody shared the mode.
export function sharedByLabel(companyIds, companies) {
  const ids = (Array.isArray(companyIds) ? companyIds : [companyIds]).filter(Boolean);
  if (ids.length === 0) return null;
  const names = ids.map((id) => (companies || []).find((c) => c.id === id)?.name ?? id);
  return `shared by ${names.join(', ')}`;
}
